import Icon from '../components/Icon.vue'

Icon.register({
  'user-injured': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M277.4 12C261.1 4.5 243.1 0 224 0 170.3 0 124.5 33.1 105.5 80H186.7L277.4 12zM342.5 80C334.6 60.5 321.8 43.8 306 30.5L240 80H342.5zM224 256C294.7 256 352 198.7 352 128 352 122.5 351.1 117.3 350.4 112H97.6C96.9 117.3 96 122.5 96 128 96 198.7 153.3 256 224 256zM80 299.7V512H208.3L109.8 290.5A132.8-132.8 0 0 1 80 299.7zM0 464C0 490.5 21.5 512 48 512V320.2C18.9 344.9 0 381.3 0 422.4V464zM256 416H200.6L243.3 512H256C282.5 512 304 490.5 304 464S282.5 416 256 416zM313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H143.7L186.4 384H256C300.1 384 336 419.9 336 464 336 482.1 329.7 498.6 319.6 512H400C426.5 512 448 490.5 448 464V422.4C448 348.2 387.8 288 313.6 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-injured.js
// module id = HQ9v
// module chunks = 144